import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeNotification } from '@gandi/notifications';
import { useTranslator, localeSelector } from '@gandi/translate';
import { Button } from '@gandi/ui';
import { useAppSelector } from '../../hooks/useAppSelector';
import { pathjoin } from '../../modules/pathjoin';
import { selectCartUUID, selectCartIsWorking } from '../../modules/selectors';
import { TotalBlock } from './DrawerContent/Footer/TotalBlock';
import { NOTIFICATION_ID } from './modules/constants';
import { selectAppName, selectShopURL } from './modules/selectors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "CheckoutButton-root_2Ygwf",
  "button": "CheckoutButton-button_LPa9K",
  "container": "CheckoutButton-container_1j26J"
};
export default function CheckoutButton(buttonProps) {
  const {
    __
  } = useTranslator();
  const dispatch = useDispatch();
  const cartId = useAppSelector(selectCartUUID);
  const locale = useAppSelector(localeSelector);
  const shopURL = useAppSelector(selectShopURL);
  const appName = useAppSelector(selectAppName);
  const working = useAppSelector(selectCartIsWorking);
  const [navigating, setNavigating] = useState(false);
  useEffect(() => {
    const handlePageShow = event => {
      if (event.persisted) {
        setNavigating(false);
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
  let to;
  let href;
  if (appName === 'shop') {
    to = cartId ? `/cart/${cartId}` : `/cart`;
  } else {
    href = pathjoin(shopURL, locale, 'cart', cartId);
  }
  const loading = buttonProps.loading || working || navigating;
  const mergedButtonProps = {
    ...buttonProps,
    onClick: () => {
      dispatch(closeNotification(NOTIFICATION_ID));
      if (href) setNavigating(true);
    },
    to,
    href: loading ? undefined : href,
    loading
  };
  if (buttonProps.small) {
    return /*#__PURE__*/_jsx(Button, {
      ...mergedButtonProps,
      children: __('<for-translators-use>Go to cart</for-translators-use>Checkout')
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    children: /*#__PURE__*/_jsx(Button, {
      ...mergedButtonProps,
      block: true,
      className: styles.button,
      children: /*#__PURE__*/_jsxs("span", {
        className: styles.container,
        children: [/*#__PURE__*/_jsx(TotalBlock, {}), /*#__PURE__*/_jsx("span", {
          children: __('Continue')
        })]
      })
    })
  });
}